import { Role } from '@/core/collections/modules/roles/role.interface';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { RoleService } from './role.service';

const service = new RoleService();

export interface RoleState {}

const RoleStore: Module<RoleState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getRoles(context, teamId: number) {
         const response = await service.getRoles(teamId);
         return response;
      },
      async addRoles(context, payload: { teamId: number; roles: Array<Role> }) {
         return await service.postRolesBatch(payload.teamId, payload.roles);
      },
      async deleteRoles(context, payload: { teamId: number; roles: Array<Role> }) {
         return await service.deleteRolesBatch(payload.teamId, payload.roles);
      },
   },
};

export default RoleStore;
